 

import React, { useEffect } from "react";
import SuitableFor from "../PressOnly/SuitableFor"
import "../PressOnly/PressOnly.css";
import { Container, Row, Col, Navbar, Nav, Button, Card, Badge, ListGroup } from 'react-bootstrap';

import AOS from "aos";
import "aos/dist/aos.css";
import CleanServicesLaundry from "../CleanServicesLaundry/CleanServicesLaundry";
import FreshNCleanApp from "../FreshNCleanApp/FreshNCleanApp";
import { useNavigate } from "react-router-dom";

const pressImg =
  "/service/OIPass.jpg";

export default function DryCleaning() {
    const navigate = useNavigate();

      useEffect(() => {
          AOS.init({
            duration: 1200,
            easing: "ease-in-out",
            once: true,
            offset: 80,
          });
        }, []);
  return (
    <div className="mt-5">


<section className="hero-section-dry-cleaning-home mt-5">
  <div className="hero-overlay-wash-fold mt-5">
    <Container fluid="xl" className="py-5 mt-4 h-100">
      <Row className="align-items-center justify-content-center text-center h-100 mt-5">
        <Col lg={8}>
          <h1 className="hero-title mb-4">
         Home Care    Your Home, Held to a Higher Standard<br />
            {/* <span className="hero-highlight-wash-fold">
           Your Home, Held to a Higher Standard
            </span> <br /> */}
          
          </h1>

          <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
            <button className="suhedule-btn-dark"
             onClick={() =>
    window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  }>
              BOOK NOW
            </button>

            <button className="view-prices-list"
            onClick={() => navigate("/laundry-price")}>
              VIEW PRICE LIST
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
</section>

     
                         
 <div className="" data-aos="zoom-in-right">
   <FreshNCleanApp/>
 </div>

 <div className="cta-banner-dark text-center text-white mb-5 mt-5">
      <h2 className="display-6 fw-bold mb-3 fade-up text-center mt-5 text-light">
        Experience the difference a professional wash makes.
      </h2>

      <p className="text-white-50 fs-5 mb-4 fade-up delay-1">
        Your garments deserve better than a standard wash. Elevate your everyday.
      </p>

      <div className="cta-btns fade-up delay-2">
        <button className="btn-downlod-app">DOWNLOAD APP</button>
        <button className="btn-whatssp-down"
         onClick={() =>
                       window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  }>WHATSAPP US</button>
      </div>
    </div>


 
      <section className="pressonly-wrap">
        <div className="pressonly-container mt-5">
          {/* LEFT IMAGE */}
          <div className="pressonly-image">
            <img src={pressImg} alt="Press Only" />
          </div>
          {/* RIGHT CONTENT */}
          <div className="pressonly-content">
            <h2 className="expertise-title">Home Care
                </h2>
            <p>
              A dry-cleaning machine is similar to a washing machine, except that it is larger and uses a closed-loop system: the solvent is recovered, filtered, and reused in the next cleaning cycle. This treatment combines mechanical action of the machine program with the efficiency of a solvent and is used for garments that cannot be washed in water because they could either shrink, discolor or lose its original shape.
              <br />
              Our fully computerized controlled machines with tailored programs, high-quality solvents, and additives along with correct loading of the machine are key to ensure the quality of cleaning. Proprietary programs, unique 100% distillation of quality solvents in recycling and quality training
              ensure the best available dry-cleaning service in the industry
            </p>


            <div className="pressonly-buttons">
              <button className="btn-book" onClick={() =>
                        window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  }>
                    
                    Book Now</button>
              <button className="btn-price" onClick={() => navigate("/laundry-price")}>Pricing</button>
            </div>
          </div>
        </div>
      </section>


         
                 
 <div className="" data-aos="zoom-in-right">
 <SuitableFor/>
 </div>
     

          <div className="" data-aos="zoom-in-right">
          <CleanServicesLaundry/>
      </div>


    </div>

  );
}
